import { axiosInstance, baseUrl } from "./auth";
import { useQuery } from 'react-query'
import { ApiStatus } from "../constants";



export const  VENDOR_LIST = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/listVendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  VENDOR_ADD = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/vendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  VENDOR_UPDATE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/updateVendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  VENDOR_DELETE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/deleteVendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}

export const  VENDOR_STATUS_CHANGE = async (body) => {
    let response = await axiosInstance.post(`${baseUrl}/inventory/toggleStatusVendor`, body)
    if (response.data.code !== ApiStatus.success) {
        throw new Error(response.data.message || ApiStatus.serverError)
    }
    return response.data
}






